import * as React from 'react';
import cx from 'classnames';

const Button = ({children, type, action, color = 'green', newTab = true, large = false}) => {
    const className = cx('btn waves-effect waves-light lighten-1', {'btn-large': large}, color);

    switch (type) {
        case 'a':
            if (newTab)
                return (
                    <a href={action} target="_blank" rel="noreferrer" className={className}>
                        {children}
                    </a>
                );
            return (
                <a href={action} className={className}>
                    {children}
                </a>
            );
        default:
            return (
                <button onClick={action} className={className}>
                    {children}
                </button>
            );
    }
};

export default Button;
